import React from 'react';
import { SelectProps } from 'antd';
import { Select } from '~/components';
import { useHandbook } from '~/controllers/handbook';

const IssuingAuthoritySelect: React.FC<SelectProps<any>> = (props) => {
  const handbook = useHandbook();
  const options = handbook.data?.handbooks
    ?.find((item) => item.key === 'tradeLicenseIssuingAuthority')
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ?.values?.map((item) => ({ label: item.localizedValue, value: item.apiValue!, key: item.key }))
    .sort((a, b) => (a.label > b.label ? 1 : -1));
  return <Select showSearch {...props} options={options} />;
};

export default IssuingAuthoritySelect;
